import { FC, useEffect } from 'react';
import CurrencyAssetsTable from './components/currencyAssetsTable.comopnent';
import { useDispatch } from 'react-redux';
import {
  addAdditionalTitleBarComponents,
  removeTitleBarComponent,
} from '../../../../redux/pages/actions';
import { InfoToggle } from '../../../../types/redux/pages/PagesStore';
import {
  APPEND_NEW_INFOTOGGLE_TO_TITLEBAR,
  REMOVE_INFOTOGGLE_FROM_TITLEBAR,
} from '../../../../types/redux/pages/pageTypes';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { useMoabPageModel } from '../../../../api/rs-hg/liquidity/hooks/queries';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import { MoabReport } from './moab.types';

const Moab: FC<FundInfoComponentProps> = (props) => {
  const activeDate = props.positionDate;

  const moabQuery = useMoabPageModel(props.fundId, activeDate);

  const dispatch = useDispatch();

  useEffect(() => {
    const infoTogglesToAdd: InfoToggle[] = [
      {
        titleBarTitle: 'Select Scenario',
        titleBarKey: 'scenarioSelection',
        displayOnOverviewPage: false,
        currentValue: '',
        message: (
          <p>
            This page shows the Maximum Achievable One-Day Balance of the fund.
            This balance is defined by the percentage of NAV the fund can
            liquidate in one day. The balance is categorised into M0, M1, M2 and
            M3.
            <br />
            <br />
            M0: Cash
            <br />
            M1: Cash, T-Bills
            <br />
            M2: Cash, All Government Bonds
            <br />
            M3: All Assets that can be liquidated in one day
          </p>
        ),
      },
    ];
    dispatch(
      addAdditionalTitleBarComponents(
        infoTogglesToAdd,
        APPEND_NEW_INFOTOGGLE_TO_TITLEBAR,
      ),
    );

    return () => {
      dispatch(
        removeTitleBarComponent(
          'scenarioSelection',
          REMOVE_INFOTOGGLE_FROM_TITLEBAR,
        ),
      );
    };
  }, [dispatch]);

  return (
    <QueryBoundary<MoabReport>
      isLoading={moabQuery.isLoading}
      isFetching={moabQuery.isFetching}
      isError={moabQuery.isError}
      error={moabQuery.error}
      data={moabQuery.data?.data}
      loadingMessages={['Loading MOAB data...']}
      noDataMessage="No MOAB data available."
    >
      {(pageData) => (
        <>
          <CurrencyAssetsTable
            fundId={props.fundId}
            baseOrAll="base"
            title="Base Currency Assets"
            data={pageData}
          />
          <CurrencyAssetsTable
            fundId={props.fundId}
            title="All Currency Assets"
            baseOrAll="all"
            data={pageData}
          />
        </>
      )}
    </QueryBoundary>
  );
};

export default Moab;
